import { useState } from "react";
import { FortuneSign } from "@/data/fortuneData";
import { FortuneDrawer } from "@/components/FortuneDrawer";
import { FortuneCard } from "@/components/FortuneCard";
import { LunarDate } from "@/components/LunarDate";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Index = () => {
  const [currentSign, setCurrentSign] = useState<FortuneSign | null>(null);

  const handleSignDrawn = (sign: FortuneSign) => {
    setCurrentSign(sign);
  };

  const handleBackToDrawer = () => {
    setCurrentSign(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-100 via-yellow-50 to-red-100">
      {/* 頂部裝飾 */}
      <div className="bg-gradient-to-r from-red-600 to-red-700 text-white py-4">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold text-center">香港黃大仙廟解簽</h1>
          <p className="text-center text-red-100 mt-2">有求必應 心誠則靈</p>
        </div>
      </div>

      {/* 農曆日期 */}
      <div className="container mx-auto px-4 py-4">
        <LunarDate />
      </div>

      {/* 主要內容 */}
      <div className="container mx-auto px-4 py-8">
        {!currentSign ? (
          <div className="space-y-8">
            <FortuneDrawer onSignDrawn={handleSignDrawn} />
            
            {/* 說明文字 */}
            <div className="max-w-2xl mx-auto bg-white p-6 rounded-lg border-2 border-red-200 shadow-lg">
              <h2 className="text-xl font-semibold text-red-800 mb-4 text-center">解簽說明</h2>
              <div className="space-y-3 text-gray-700">
                <p>• <strong>簽文來源：</strong>香港黃大仙廟傳統簽文，共60簽</p>
                <p>• <strong>解簽內容：</strong>包含簽詩、簽意及家宅、事業、學業、命運、健康、感情六個方面的詳細解釋</p>
                <p>• <strong>簽文等級：</strong>分為上上、上中、上下、中上、中中、中下、下上、下中、下下九個等級</p>
                <p>• <strong>使用方法：</strong>可選擇隨機抽簽或輸入特定簽號查看</p>
                <p className="text-red-600 font-medium">• <strong>重要提醒：</strong>簽文僅供參考，命運掌握在自己手中，積德行善最重要</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="flex justify-center">
              <Button 
                onClick={handleBackToDrawer}
                variant="outline"
                className="border-red-300 text-red-700 hover:bg-red-50"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                重新抽簽
              </Button>
            </div>
            <FortuneCard sign={currentSign} />
          </div>
        )}
      </div>

      {/* 底部說明 */}
      <footer className="bg-gradient-to-r from-red-600 to-red-700 text-white py-6 mt-12">
        <div className="container mx-auto px-4 text-center">
          <p className="text-red-100">黃大仙師傅慈悲為懷，有求必應</p>
          <p className="text-red-200 text-sm mt-2">本網站僅供娛樂參考，請理性對待</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
